<template>
    <div
        id="login-box"
        class="login-box">
        <div class="login-title">
            金盒子智能管理系统
        </div>
        <input
            v-model="username"
            class="login-input"
            type="text"
            name="firstname"
            placeholder="请输入手机号">
        <input
            v-model="password"
            class="login-input"
            type="password"
            name="firstname"
            placeholder="请输入登录密码">
        <button
            v-on:click="login"
            class="login-button">
            登录
        </button>
    </div>
</template>

<script>
import message from 'ant-design-vue/lib/message';

export default {
    name: 'LoginDialog',
    data() {
        return {
            username: '',
            password: ''
        };
    },
    methods: {
        login() {
            const url = process.env.VUE_APP_API_SERVER + '/user/login';
            var data = {
                Username: this.username,
                Password: this.password
            };

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: new Headers({
                    'Content-Type': 'application/json',
                })
            }).then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
                .catch(error => {
                    if (error.status == 502) {
                        message.error('服务器无法访问');
                    } else if (error.status == 500) {
                        message.error('服务器内部错误，请联系开发者');
                    } else if (error.status == 403) {
                        message.error('用户名和密码不正确，请检查后重新登录');
                    }
                })
                .then(response => {
                    if (response.token && response.token != '') {
                        localStorage.setItem("role", response.role)
                        localStorage.setItem('accessToken', response.token);
                        localStorage.setItem('username', response.username);
                        this.$router.replace('/home');
                    } else {
                        message.error('服务器没有返回访问令牌');
                    }
                });
        }
    }
};
</script>

<style scoped>
.login-box {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 5px;
    padding: 20px;
    width: 440px;
    height: 320px;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid #EEE;
}

.login-title {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.login-input {
    margin-top: 20px;
    border-radius: 3px;
    padding: 10px;
    width: 260px;
    font-size: 16px;
    background-color: rgba(255, 255, 255, 0.5);
    outline: medium;
    border: 1px solid #eee;
}

.login-button {
    margin-top: 40px;
    border: none;
    border-radius: 3px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 120px;
    font-size: 18px;
    color: #FFF;
    background-color: #5CC9F5;
}

/* 禁止 Chrome 自动填充修改 input 样式 */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}
</style>
